import { MdOutlineCloudUpload } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import imgUrlChange from "../../utils/imgUrlChanger";
import {
  setSelectedPipeline,
  setSelectedVideoHome,
} from "../../redux/slice/videoSlice";
import { useEffect, useRef, useState } from "react";
import LoaderCircle from "../../commonComponents/loader/LoaderCircle";
import { Link, useNavigate } from "react-router-dom";
import { message } from "antd";

function Hero() {
  const { fourVideo } = useSelector((data) => data.videoReducer);
  const [loading, setLoading] = useState(false);
  const videoRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(setSelectedPipeline({}));
    dispatch(setSelectedVideoHome(null));
  }, []);
  useEffect(() => {
    const playVideo = async () => {
      try {
        if (videoRef && videoRef.current) {
          await videoRef.current.play();
        }
      } catch (error) {
        console.error("Autoplay was prevented:", error);
        message.error("Autoplay was prevented");
      }
    };
    playVideo();
  }, [videoRef]);
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      dispatch(setSelectedVideoHome(file));
      navigate("/auth/workspace");
    }
  };
  const sampleVideoSelced = (item) => {
    const randomNumber = Math.floor(Math.random() * 9000000) + 1000000;
    let data = {
      ...item,
      _id: "test",
      videoId: { ...item.videoId, title: item.videoId.title + randomNumber },
    };
    dispatch(setSelectedPipeline(item));
    navigate("/auth/workspace");
  };
  return (
    <section id="hero" className="hero d-flex align-items-center">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 d-flex flex-column justify-content-center">
            <h1 data-aos="fade-up">
              Pratham - Empowering You with Vision AI Insights
            </h1>
            <h2 data-aos="fade-up" data-aos-delay="400">
              Welcome to Pratham, the revolutionary video analytics platform
              that puts the power of Vision AI directly into your hands. For the
              first time, no code, no AI expert – just your creativity and our
              cutting-edge technology. Pratham is more than a platform; it's
              your gateway to unlocking the potential within your videos.
            </h2>
            <div data-aos="fade-up" data-aos-delay="600">
              <div className="text-center text-lg-start">
                <Link
                  to="/auth/workspace"
                  className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center p-4"
                >
                  <span>Get Started Free </span>
                  {/* <LuMoveRight className="bi bi-arrow-right mx-1" /> */}
                </Link>
              </div>
            </div>
          </div>
          <div
            className="col-lg-6 hero-img d-flex justify-content-end align-items-center flex-column"
            data-aos="zoom-out"
            data-aos-delay="200"
          >
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center draggDownBox2"
                style={{ height: "350px", width: "600px" }}
              >
                <LoaderCircle />
              </div>
            ) : (
              <video
                className="draggDownBox2"
                ref={videoRef}
                width="600"
                height="350"
                autoplay
                muted
                loop
                playsInline
                style={{ borderRadius: "8px" }}
              >
                <source src="assets/img/video.mp4" type="video/mp4" />
              </video>
            )}

            <div className="draggDownBox">
              {fourVideo?.map((item, i) => (
                <div
                  className="draginnerBox"
                  key={i}
                  onClick={() => {
                    sampleVideoSelced(item);
                    setLoading(true);
                  }}
                >
                  <img
                    src={imgUrlChange(item.videoId.imgPath)}
                    style={{ objectFit: "contain" }}
                    alt="not found"
                    height={100}
                  />
                </div>
              ))}
              <div className="dragbox">
                <label
                  htmlFor="file"
                  className=" d-flex align-items-center justify-content-center flex-column"
                  style={{ cursor: "pointer" }}
                >
                  <MdOutlineCloudUpload size={40} color="#4154f1 " />
                </label>
                <input
                  type="file"
                  id="file"
                  style={{ display: "none" }}
                  accept="video/*"
                  onChange={handleFileChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
